import types from './types';
import store from '../../../config/redux/store';
import { asyncGet } from '../../../config/rest/async-action-creator';

export default {
  getActivity: (slug, customStore) => asyncGet(
    customStore || store,
    types.GET_ACTIVITY,
    `custom-activity/${slug}`,
  ),
  getActivityPreview: (id, customStore) => asyncGet(
    customStore || store,
    types.GET_ACTIVITY_PREVIEW,
    `custom-activity-preview/${id}`,
  ),
  incrementRecommendations: (id) => asyncGet(
    store,
    types.INCREMENT_RECOMMENDATIONS,
    `increment-recommendations/${id}`,
  ),
  reinitializeActivity: () => ({
    store,
    type: types.REINITIALIZE_ACTIVITY,
  }),
};



// WEBPACK FOOTER //
// ./src/app/actions/activity/index.js